<script setup lang="ts">
import type { SelectLabelProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { SelectLabel } from 'reka-ui';
import { cn } from '@/utils/shadcn/lib/utils.ts';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<SelectLabelProps & { class?: HTMLAttributes['class'] }>();
</script>

<template>
    <SelectLabel
        data-slot="select-label"
        :class="cn('text-muted-foreground px-2 py-1.5 text-xs', props.class)"
    >
        <slot></slot>
    </SelectLabel>
</template>
